module.exports = "/static/bin/bootloader.bin";